import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m10.819 12.684-1.575-1.418a1.14 1.14 0 0 0-.788-.304q-.45 0-.787.304a.94.94 0 0 0 0 1.443l2.362 2.152q.338.303.788.304.45 0 .787-.304l4.781-4.304a.94.94 0 0 0 0-1.443 1.16 1.16 0 0 0-.801-.304q-.465 0-.802.304zM12 22a2.4 2.4 0 0 1-.703-.101Q7.5 20.759 5.25 17.683 3 14.608 3 11.063V6.278q0-.632.408-1.139a2.3 2.3 0 0 1 1.055-.734l6.75-2.278A2.6 2.6 0 0 1 12 2q.394 0 .787.127l6.75 2.278q.648.228 1.055.734.408.507.408 1.14v4.784q0 3.545-2.25 6.62t-6.047 4.216A2.4 2.4 0 0 1 12 22m0-2.025q2.925-.835 4.837-3.342 1.913-2.506 1.913-5.57V6.278L12 4 5.25 6.278v4.785q0 3.063 1.912 5.57Q9.076 19.139 12 19.975" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }